export enum HeaderAlignment {
  LEFT   = 'start center',
  CENTER = 'center',
  RIGHT  = 'end center',
}
